import React, { useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Card,
  Upload,
  Select,
  Modal,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import Post from "../services/Post";
import { UploadOutlined } from "@ant-design/icons";
import Cropper from "react-easy-crop";

const AddMember = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const { type } = useParams();

  const [imageBase64, setImageBase64] = useState();
  const [processing, setProcessing] = useState(false);
  const [classFilter, setClassFilter] = useState("Pre-Nursery");
  const [sectionFilter, setSectionFilter] = useState("A");
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  console.log("user", user);

  const classOptions = [
    "Pre-Nursery",
    "Nursery",
    "KG",
    "LKG",
    "UKG",
    "1st",
    "2nd",
    "3rd",
    "4th",
    "5th",
    "6th",
    "7th",
    "8th",
    "9th",
    "10th",
    "11th",
    "12th",
  ].map((className) => ({
    label: className,
    value: className,
  }));

  const sectionOptions = [
    ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)),
  ].map((letter) => ({
    label: letter,
    value: letter,
  }));

  const handleImageUpload = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setImageSrc(reader.result);
      setModalVisible(true); // Open crop modal
    };
    return false; // Prevent automatic upload
  };

  const onCropComplete = (_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const cropAndSaveImage = async () => {
    if (!imageSrc || !croppedAreaPixels) return;

    const croppedBase64 = await getCroppedImg(imageSrc, croppedAreaPixels);
    const base64String = croppedBase64.split(",")[1]; // Extract base64 data
    setImageBase64(base64String);
    setModalVisible(false);
  };

  const getCroppedImg = (imageSrc, cropArea) => {
    return new Promise((resolve) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 120;
        canvas.height = 120;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
          image,
          cropArea.x,
          cropArea.y,
          cropArea.width,
          cropArea.height,
          0,
          0,
          120,
          120
        );

        resolve(canvas.toDataURL("image/webp")); // Return cropped base64
      };
    });
  };

  const handleClassChange = (value) => {
    setClassFilter(value);
  };

  const handleSectionChange = (value) => {
    setSectionFilter(value);
  };

  const onFinish = (values) => {
    if (values.password !== values.confirm_password) {
      message.error("Passwords do not match!");
      return;
    }
    console.log("Form Data Submitted:", values);
    const formData = {
      name: values.name,
      mobile: values.mobile,
      member_type: type,
    };

    Post.AddMember(formData).then((res) => {
      console.log(res);

      if (res.error) {
        message.error(res.error);
      } else {
        // Store the updated user data in localStorage
        message.success("Member created successfully!");
        navigate("/user/members");
      }
    });
  };

  const handleFormSubmit = (values) => {
    const studentData = {
      ...values,
      profile: imageBase64,
    };
    setProcessing(true);

    console.log("New Student Data:", studentData);

    Post.AddStudent(studentData)
      .then((res) => {
        console.log(res);
        if (res.error) {
          message.error(res.error);
        } else {
          // Store the updated user data in localStorage
          // message.success("Member created successfully!");
          message.success("Student added successfully!");
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setProcessing(false);
      });

    form.resetFields();
    setImageBase64(""); // Reset the image field
  };

  return (
    <Row justify="center" align="middle">
      <Col xs={22} sm={16} md={12} lg={8}>
        <Card>
          <Form
            form={form}
            name="user-details-form"
            initialValues={{
              class: classFilter,
              section: sectionFilter,
            }}
            onFinish={type == "student" ? handleFormSubmit : onFinish}
            layout="vertical"
          >
            <Form.Item
              label="Name"
              name="name"
              rules={[{ required: true, message: "Please enter full name!" }]}
            >
              <Input placeholder="Enter full name" />
            </Form.Item>

            {type == "student" && (
              <>
                <Form.Item
                  name="class"
                  label="Student Class"
                  rules={[
                    { required: true, message: "Please enter student class" },
                  ]}
                >
                  {/* <Input placeholder="Enter student class" /> */}
                  <Select
                    size="middle"
                    onChange={handleClassChange}
                    style={{
                      width: "100%",
                    }}
                    value={classFilter}
                    options={classOptions}
                  />
                </Form.Item>

                <Form.Item
                  name="section"
                  label="Student Section"
                  rules={[
                    { required: true, message: "Please enter student section" },
                  ]}
                >
                  {/* <Input placeholder="Enter student section" /> */}
                  <Select
                    size="middle"
                    onChange={handleSectionChange}
                    style={{
                      width: "100%",
                    }}
                    value={sectionFilter}
                    options={sectionOptions}
                  />
                </Form.Item>

                <Form.Item
                  name="admission_no"
                  label="Admission Number"
                  rules={[
                    {
                      required: true,
                      message: "Please enter student admission number",
                    },
                  ]}
                >
                  <Input placeholder="Enter student admission number" />
                </Form.Item>

                <Form.Item label="Profile Picture">
                  <Upload
                    accept="image/*"
                    beforeUpload={handleImageUpload}
                    showUploadList={false}
                  >
                    <Button icon={<UploadOutlined />}>
                      Upload Profile Picture
                    </Button>
                  </Upload>

                  {imageBase64 && (
                    <img
                      src={`data:image/webp;base64,${imageBase64}`}
                      alt="Profile Preview"
                      style={{
                        marginTop: 10,
                        width: 120,
                        height: 120,
                        borderRadius: 8,
                      }}
                    />
                  )}

                  {/* Cropper Modal */}
                  <Modal
                    open={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    onOk={cropAndSaveImage}
                    title="Crop Image"
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: 300,
                      }}
                    >
                      <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropComplete}
                      />
                    </div>
                  </Modal>
                </Form.Item>

                <Form.Item
                  label="Parent Name"
                  name="parent_name"
                  rules={[
                    { required: true, message: "Please enter parent name!" },
                  ]}
                >
                  <Input placeholder="Enter full name" />
                </Form.Item>
              </>
            )}

            <Form.Item
              label="Mobile"
              name="mobile"
              rules={[
                { required: true, message: "Please enter mobile number!" },
              ]}
            >
              <Input placeholder="Enter Mobile Number" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={processing}
                style={{
                  backgroundColor: "#a6cc43",
                  borderColor: "#a6cc43",
                  color: "#FFFFFF",
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

export default AddMember;
